import { localStg } from '@/utils';

/** 获取本地语言缓存 */
export function getLang() {
  return localStg.get('lang') || 'zh-CN';
}
